/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Greg Sarpy, Leonid Khramov
 */

export const integer = (val) => {
    let cval = parseInt(val, 10)
    return `${cval}`
}

export const percent = (val) => {
    let cval = Math.round(val)
    return `${cval}%`
}

export const double = (val) => {
    var cval = Math.floor(val * 10)/10
    return `${cval}`
}

export const ordinal = (val) => {
    let cval = parseInt(val, 10)
    var suffix
    switch(cval) {
    case 1:
        suffix = 'st'
        break
    case 2:
        suffix = 'nd'
        break
    case 3:
        suffix = 'rd'
        break
    default:
        suffix = 'th'
        break
    }
    return `${cval}${suffix}`
}

export const statHighlight = (stat, playerCount, shouldDistinguishStat = true) => {
    const goodBoundary = Math.floor(playerCount * 0.2)

    var val = ''
    if (stat === 0 && shouldDistinguishStat) {
        val = 'top-stat'
    } else if (stat <= goodBoundary && shouldDistinguishStat) {
        val = 'above-avg-stat'
    }
    return val
}

export const utcDateStringToDate = str => {
    var parts = str.split('-')
    if (parts.length === 3) {
        var date = new Date(Date.UTC(parts[0], parts[1], parts[2]))
        return date
    } else {
        throw('utcDateStringToDate invalid format') // eslint-disable-line no-throw-literal
    }
}

export const dateToShortString = date => {
    var y = date.getFullYear()
    var m = date.getMonth()
    var d = date.getDate()
    return `${m}/${d}/${y}`
}

export const secondsToFormattedTime = (seconds) => {
    if(seconds === undefined || seconds === null || typeof seconds !== 'number')
    {
        return '0:00'
    }

    // Calculate hour minute and second
    var _tot = seconds
    // disabling hours for now
    var _hr = 0 //Math.floor(_tot / 3600);
    _tot = _tot - (_hr * 3600)

    var _min = Math.floor(_tot / 60)
    _tot = _tot - (_min * 60)

    var _sec = Math.floor(_tot)

    // 0 pad min and sec if needed
    if (_hr > 0 && _min < 10) {
        _min = '0' + _min
    }
    if (_sec < 10) {
        _sec = '0' + _sec
    }

    var str = `${_min}:${_sec}`
    return str
}

export const roughTimeEstimate = (seconds) => {
    var text = ''

    if(seconds < 10) {
        let secs = Math.ceil(seconds)
        text = `${secs} seconds`
    } else if (seconds < 60) {
        let secs = Math.floor(seconds/10)*10
        text = `about ${secs} seconds`
    } else if (seconds < 60 * 60) {
        var min = Math.floor(seconds / 60)
        text = `about ${min} min`
    } else {
        var hrs = Math.ceil(seconds / 60 / 60)
        text = `about ${hrs} hrs`
    }
    return text
}

export const dateToLongString = (date) => {
    if (!date) { return '--' }
    var m = monthToLongString(date.getMonth())
    var d = ordinal(date.getDate())
    return `${m} ${d}, ${date.getFullYear()}`
}

export const monthToLongString = (month) => {
    var mon = ''
    if (month === 0) { mon = 'January' }
    else if (month === 1) { mon = 'February' }
    else if (month === 2) { mon = 'March' }
    else if (month === 3) { mon = 'April' }
    else if (month === 4) { mon = 'May' }
    else if (month === 5) { mon = 'June' }
    else if (month === 6) { mon = 'July' }
    else if (month === 7) { mon = 'August' }
    else if (month === 8) { mon = 'September' }
    else if (month === 9) { mon = 'October' }
    else if (month === 10) { mon = 'November' }
    else if (month === 11) { mon = 'December' }
    return mon
}

export const utcTimeToArray = (epochTimeMillis) => {
    let date = new Date(epochTimeMillis)
    return [
        date.getUTCFullYear(),
        date.getUTCMonth()+1,
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ]
}
